import router from '@ps/router'
export const entryLink = '/ps.html#/'

const assetTypes = {
  particle: 'particle',
  scene: 'scene',
  dragonBone: 'dragonBone',
}
const pageModes = {
  editProject: 'edit-project',
  editPrefab: 'edit-prefab',
}
export const workbenchRoute = {
  // 页面 query 参数列表
  query: {
    id: 'id',
    assetId: 'asset_id',
    assetType: 'asset_type',
    newResource: 'new_resource',
  },
  name: 'workbench',
  assetTypes,
  pageModes,
}

export enum PageType {
  Workbench = 'workbench', // 自由编辑器
  Iv = 'iv', // 互动视频编辑器
}
export const getPageType = () => {
  return router.currentRoute.name
}
// 是否互动视频编辑页
export const isIvPage = (): boolean => {
  return router.currentRoute.name === PageType.Iv
}
// 统计区分ps和iv
export const getLogToolType = (): string => {
  if (router?.currentRoute?.name) {
    if (router.currentRoute.name === PageType.Iv) {
      return 'iv'
    }
    return 'ps'
  }
  let t = window.location.href.slice(window.location.href.lastIndexOf('/') + 1)
  t = t.slice(0, t.indexOf('?'))
  if (t === PageType.Iv) {
    return 'iv'
  }
  return 'ps'
}
